import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ContactSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ContactSVG;
